import React from 'react';
import Skeleton from 'react-loading-skeleton';

const CustomEditorSkeleton = () => {
    return (
        <div className='bottom_bar group_conv relative bgSurfaceDark !p-3 !h-[75px]'>
            <div className='flex gap-5 items-center justify-between w-full mt-2.5'>
                <div className='flex items-center gap-3'>
                    <div className='flex items-center gap-2'>
                        <Skeleton height={25} width={25} borderRadius={4} />
                        <Skeleton height={25} width={25} borderRadius={4} />
                    </div>
                    <div className=''>
                        <Skeleton height={25} width={160} borderRadius={4} />
                    </div>
                </div>
                <div className='flex items-center gap-2'>
                    <Skeleton height={25} width={25} borderRadius={4} />
                    <Skeleton height={25} width={25} borderRadius={4} />
                </div>
            </div>
        </div>
    );
};

export default CustomEditorSkeleton;